import { render } from "./EmptyInfoBlock.vue?vue&type=template&id=3fbdef6f"
import script from "./EmptyInfoBlock.vue?vue&type=script&lang=js"
export * from "./EmptyInfoBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__